let searchSavedScrollY = 0;

function preventSearchTouch(e) {
    if (e.target.closest('.search-inner')) {
        return;
    }
    e.preventDefault();
}

function lhmToggleSearch() {
    if (window.matchMedia('(min-width: 85.375em)').matches) {
        return;
    }

    const isOpen = document.body.classList.contains('searchOpen');

    document.querySelectorAll('.searchToggler').forEach((toggler) => {
        toggler.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    if (isOpen) {
        document.body.classList.remove('lockScroll', 'searchOpen');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overscrollBehavior = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.position = '';
        document.documentElement.style.width = '';
        document.removeEventListener('touchmove', preventSearchTouch);
        window.scrollTo(0, searchSavedScrollY);
    } else {
        searchSavedScrollY = window.scrollY;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        document.body.classList.add('searchOpen');

        setTimeout(() => {
            document.body.classList.add('lockScroll');
            document.body.style.position = 'fixed';
            document.body.style.top = '0';
            document.body.style.width = '100%';
            document.body.style.overscrollBehavior = 'none';
            document.documentElement.style.overflow = 'hidden';
            document.documentElement.style.position = 'fixed';
            document.documentElement.style.width = '100%';
            document.addEventListener('touchmove', preventSearchTouch, { passive: false });

            const input = document.querySelector('.searchPanelInput');
            if (input) {
                input.focus();
            }
        }, 50);
    }
}

function openDesktopSearchPopup(toggler, popup) {
    popup.hidden = false;
    toggler.setAttribute('aria-expanded', 'true');

    const input = popup.querySelector('.searchPanelInput');
    if (input) {
        input.focus();
    }
}

function closeDesktopSearchPopup(toggler, popup, returnFocus) {
    popup.hidden = true;
    toggler.setAttribute('aria-expanded', 'false');

    if (returnFocus) {
        toggler.focus();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.searchToggler').forEach((toggler) => {
        const controlsId = toggler.getAttribute('aria-controls');
        const controlsEl = controlsId ? document.getElementById(controlsId) : null;
        const isDesktopPopup = controlsEl && controlsEl.classList.contains('searchPopup');

        toggler.addEventListener('click', () => {
            if (isDesktopPopup) {
                if (controlsEl.hidden) {
                    openDesktopSearchPopup(toggler, controlsEl);
                } else {
                    closeDesktopSearchPopup(toggler, controlsEl, false);
                }
                return;
            }

            lhmToggleSearch();
        });
    });

    const desktopPopup = document.getElementById('desktopSearchPopup');
    const desktopToggler = document.querySelector('.searchToggler[aria-controls="desktopSearchPopup"]');

    if (desktopPopup && desktopToggler) {
        document.addEventListener('click', (e) => {
            if (desktopPopup.hidden) {
                return;
            }

            if (!desktopPopup.contains(e.target) && !desktopToggler.contains(e.target)) {
                closeDesktopSearchPopup(desktopToggler, desktopPopup, false);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !desktopPopup.hidden) {
                closeDesktopSearchPopup(desktopToggler, desktopPopup, true);
            }
        });
    }

    document.querySelectorAll('.searchCloseButton').forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            lhmToggleSearch();
        });
    });

    const searchOverlay = document.querySelector('.searchOverlay');
    if (searchOverlay) {
        searchOverlay.addEventListener('click', () => {
            lhmToggleSearch();
        });
    }
});
